import React from "react";
import { Flame, Zap } from "lucide-react";
import { useContent } from "../context/ContentContext";

const About = () => {
  const { player } = useContent();
  return (
    <section id="about" className="relative py-24 md:py-32 bg-neutral-950 border-t border-neutral-900">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="sticky top-28">
            <div className="flex items-center gap-3 mb-4">
              <span className="accent-bar" />
              <span className="text-xs uppercase tracking-[0.35em] text-neutral-400 font-heading">
                01 — About
              </span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl text-white leading-none">
              THE <br />
              <span className="text-red-600">BLUEPRINT</span>
            </h2>
          </div>
        </div>

        <div className="lg:col-span-8">
          <p className="text-lg md:text-xl leading-relaxed text-neutral-300">
            {player.bio}
          </p>

          <div className="mt-10 grid md:grid-cols-2 gap-5">
            {player.playstyle.map((p, idx) => (
              <div
                key={p.name}
                className="stat-card group relative border border-neutral-800 bg-neutral-900/50 rounded-sm p-6"
              >
                <div className="flex items-center justify-between mb-3">
                  <div className="w-10 h-10 rounded-sm bg-red-600/10 border border-red-600/30 flex items-center justify-center">
                    {idx === 0 ? (
                      <Flame className="w-5 h-5 text-red-500" />
                    ) : (
                      <Zap className="w-5 h-5 text-red-500" />
                    )}
                  </div>
                  <span className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 font-heading">
                    Modeled After
                  </span>
                </div>
                <div className="font-display text-3xl text-white">{p.name}</div>
                <div className="mt-1 text-sm uppercase tracking-[0.2em] text-red-500 font-heading">
                  {p.trait}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 border-l-2 border-red-600 pl-6 py-2">
            <p className="text-neutral-200 italic text-lg">
              “High-motor player focused on technique, power, and explosion.”
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
